import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import Icon from '../../components/AppIcon';

// Import components
import ProfileImageUpload from './components/ProfileImageUpload';
import PersonalInfoForm from './components/PersonalInfoForm';
import SecuritySettingsForm from './components/SecuritySettingsForm';
import NotificationPreferences from './components/NotificationPreferences';
import BusinessInfoForm from './components/BusinessInfoForm';
import AccountDeletionSection from './components/AccountDeletionSection';

//import logo
// import Logo from '../../../public/assets/images/logo.png';

const UserProfile = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('personal');
  const [profileImage, setProfileImage] = useState();

  // Mock user data
  const userData = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    nationalId: '',
    birthDate: '',
    address: '',
  };

  const businessData = {
    businessName: ' ',
    businessType: '  ',
    businessPhone: '',
    businessEmail: '',
    businessAddress: '',
    businessLicense: '',
    taxId: '',
    website: '',
    instagram: '',
    description: '',
  };

  const notificationPreferences = {
    emailNotifications: {
      appointments: true,
      reminders: true,
      marketing: false,
      systemUpdates: true,
      reports: true,
    },
    smsNotifications: {
      appointments: true,
      reminders: false,
      marketing: false,
      emergencies: true,
    },
    pushNotifications: {
      realTime: true,
      daily: false,
      weekly: true,
    },
  };

  const tabs = [
    {
      id: 'personal',
      label: 'اطلاعات شخصی',
      icon: 'User',
      description: 'مدیریت اطلاعات حساب کاربری',
    },
    {
      id: 'business',
      label: 'اطلاعات کسب‌وکار',
      icon: 'Building2',
      description: 'مدیریت اطلاعات خدمات دهنده و کسب‌وکار',
    },
    {
      id: 'security',
      label: 'امنیت حساب',
      icon: 'Shield',
      description: 'تغییر رمز عبور و تنظیمات امنیتی',
    },
    {
      id: 'notifications',
      label: 'اعلان‌ها',
      icon: 'Bell',
      description: 'تنظیم نحوه دریافت اعلان‌ها',
    },
    {
      id: 'danger',
      label: 'حذف حساب',
      icon: 'Trash2',
      description: 'حذف دائمی حساب کاربری',
    },
  ];

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleImageChange = (file, preview) => {
    setProfileImage(preview);
    console.log('Profile image changed:', file);
  };

  const handlePersonalInfoSave = (data) => {
    console.log('Personal info saved:', data);
    // Show success message
    alert('اطلاعات شخصی با موفقیت ذخیره شد');
  };

  const handlePasswordChange = (data) => {
    console.log('Password changed:', data);
    // Show success message
    alert('رمز عبور با موفقیت تغییر کرد');
  };

  const handleNotificationsSave = (preferences) => {
    console.log('Notification preferences saved:', preferences);
    // Show success message
    alert('تنظیمات اعلان‌ها با موفقیت ذخیره شد');
  };

  const handleBusinessInfoSave = (data) => {
    console.log('Business info saved:', data);
    // Show success message
    alert('اطلاعات کسب‌وکار با موفقیت ذخیره شد');
  };

  const handleAccountDelete = () => {
    console.log('Account deletion requested');
    // Redirect to login or show confirmation
    alert('درخواست حذف حساب ثبت شد. حساب شما در ۳۰ روز آینده حذف خواهد شد.');
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'personal':
        return (
          <div className="space-y-8">
            <ProfileImageUpload
              currentImage={profileImage}
              onImageChange={handleImageChange}
            />
            <PersonalInfoForm
              initialData={userData}
              onSave={handlePersonalInfoSave}
            />
          </div>
        );

      case 'business':
        return (
          <BusinessInfoForm
            initialData={businessData}
            onSave={handleBusinessInfoSave}
          />
        );

      case 'security':
        return <SecuritySettingsForm onPasswordChange={handlePasswordChange} />;

      case 'notifications':
        return (
          <NotificationPreferences
            initialPreferences={notificationPreferences}
            onSave={handleNotificationsSave}
          />
        );

      case 'danger':
        return <AccountDeletionSection onAccountDelete={handleAccountDelete} />;

      default:
        return null;
    }
  };

  const activeTabData = tabs?.find((tab) => tab?.id === activeTab);

  return (
    <div className="min-h-screen bg-background" dir="rtl">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {/* <Header isCollapsed={false} onToggleSidebar={handleSidebarToggle} /> */}
      <main className="lg:mr-60 pt-16">
        <div className="p-6 max-w-7xl mx-auto">
          {/* Header section */}
          <div className="mb-8">
            <BreadcrumbNavigation className="mb-4" />

            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-foreground mb-2">
                  پروفایل کاربری
                </h1>
                <p className="text-muted-foreground">
                  مدیریت اطلاعات حساب کاربری و تنظیمات شخصی
                </p>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="User" size={24} color="white" />
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium text-foreground">
                    {userData?.firstName} {userData?.lastName}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {userData?.email}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* Sidebar navigation */}
            <div className="lg:col-span-1">
              <div className="bg-card border border-border rounded-lg p-4 sticky top-24">
                <nav className="space-y-2">
                  {tabs?.map((tab) => (
                    <button
                      key={tab?.id}
                      onClick={() => setActiveTab(tab?.id)}
                      className={`
                        w-full flex items-center gap-3 px-3 py-3 rounded-md text-right transition-colors duration-150
                        ${
                          activeTab === tab?.id
                            ? 'bg-primary text-primary-foreground shadow-sm'
                            : 'text-foreground hover:bg-muted'
                        }
                        ${
                          tab?.id === 'danger'
                            ? 'hover:bg-error/10 hover:text-error'
                            : ''
                        }
                      `}>
                      <Icon
                        name={tab?.icon}
                        size={20}
                        color={
                          activeTab === tab?.id
                            ? 'currentColor'
                            : tab?.id === 'danger'
                            ? '#DC2626'
                            : 'currentColor'
                        }
                      />
                      <div className="flex-1 text-right">
                        <div className="text-sm font-medium">{tab?.label}</div>
                        <div className="text-xs opacity-75 mt-0.5">
                          {tab?.description}
                        </div>
                      </div>
                    </button>
                  ))}
                </nav>
              </div>
            </div>

            {/* Main content */}
            <div className="lg:col-span-3">
              <div className="bg-card border border-border rounded-lg">
                {/* Tab header */}
                <div className="p-6 border-b border-border">
                  <div className="flex items-center gap-3">
                    <Icon
                      name={activeTabData?.icon}
                      size={24}
                      className={
                        activeTab === 'danger' ? 'text-error' : 'text-primary'
                      }
                    />
                    <div>
                      <h2 className="text-xl font-semibold text-foreground">
                        {activeTabData?.label}
                      </h2>
                      <p className="text-sm text-muted-foreground mt-1">
                        {activeTabData?.description}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Tab content */}
                <div className="p-6">{renderTabContent()}</div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserProfile;
